import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ProjectCard } from "../../components/ProjectCard";
import styles from "../../styles/Projects.module.css";
import { listenForProjects } from "../../lib/firebase/firestore";
import { Project } from '../../types';

export const Projects = () => {
  const [projects, setProjects] = useState<Project[]>([]);
  console.log(projects);

  useEffect(() => {
    const unsubscribe = listenForProjects(setProjects);

    return () => {
      unsubscribe(); // Clean up subscription
    };
  }, []);

  return (
    <div className={styles.projectsContainer}>
      <motion.h1
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className={styles.projectsTitle}
      >
        Projects
      </motion.h1>

      <div className={styles.projectsGrid}>
        {projects.map((project) => (
          <Link
            to={`/projects/${project.id}`}
            key={project.id}
            className={styles.cardLink}
          >
            <ProjectCard project={project} />
          </Link>
        ))}
      </div>
    </div>
  );
};
